/* bm-legal: contents list for the legal document (built from the document's own headings) with an active item on scroll.
   Without JavaScript the contents list stays hidden and the document reads straight through. */
(function () {
  var doc = document.getElementById('lg-doc');
  var toc = document.getElementById('lg-toc');
  if (!doc || !toc) return;
  var heads = [].slice.call(doc.querySelectorAll('h2, h3, h4')).filter(function (h) { return h.textContent.replace(/\s+/g, ' ').trim() && !h.closest('.shopify-policy__title'); });
  if (heads.length < 2) return;
  var list = toc.querySelector('ol');
  var top = Math.min.apply(null, heads.map(function (h) { return +h.tagName.charAt(1); }));
  var links = [], seenTop = false;
  heads.forEach(function (h, i) {
    if (!h.id) h.id = 'lg-s' + (i + 1);
    var li = document.createElement('li');
    var lvl = +h.tagName.charAt(1);
    if (lvl > top && seenTop) li.className = 'lg-sub';
    if (lvl === top) seenTop = true;
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.replace(/\s+/g, ' ').trim().replace(/[:\s]+$/, '');
    li.appendChild(a);
    list.appendChild(li);
    links.push(a);
  });
  toc.hidden = false;

  var wide = window.matchMedia('(min-width:900px)');
  function sync() { if (wide.matches) toc.setAttribute('open', ''); else toc.removeAttribute('open'); }
  sync();
  if (wide.addEventListener) wide.addEventListener('change', sync); else wide.addListener(sync);
  toc.addEventListener('toggle', function () { if (wide.matches && !toc.open) toc.open = true; });
  list.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('a') && !wide.matches) toc.removeAttribute('open'); });

  var current = -1, queued = false;
  function mark() {
    queued = false;
    var idx = 0;
    for (var i = 0; i < heads.length; i++) { if (heads[i].getBoundingClientRect().top <= 140) idx = i; else break; }
    if (window.scrollY < 40) idx = -1;
    if (idx === current) return;
    current = idx;
    links.forEach(function (a, i) { if (i === idx) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
  }
  function onScroll() { if (!queued) { queued = true; window.requestAnimationFrame(mark); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  mark();
})();
